export default __webpack_public_path__ + "static/media/close.37c932a7.png";